<template>
  <div>
    <div class="pg-story-meta">
      <CodeConnectBadge :status="story.codeConnect" />
      <a v-if="story.figmaUrl" class="pg-story-meta__link" :href="story.figmaUrl" target="_blank" rel="noopener">
        Open {{ story.name }} in Figma ↗
      </a>
      <span v-else class="pg-story-meta__none">No Figma node mapped</span>
    </div>

    <component :is="storyComponent" />
  </div>
</template>

<script setup lang="ts">
  import CodeConnectBadge from '../../../figma-playground/CodeConnectBadge.vue';
  import { findStory, resolveStoryComponent, stories } from '../../../figma-playground/stories';

  const route = useRoute();

  // Param-only navigation remounts the page (Nuxt keys it on the resolved route path), so
  // this runs again for every component — a bad slug can't leave the previous story on screen.
  const slug = typeof route.params.component === 'string' ? route.params.component : undefined;
  const story = findStory(slug);

  if (!story) {
    throw createError({
      statusCode: 404,
      statusMessage: `No Figma story for "${slug}". Known: ${stories.map((item) => item.slug).join(', ')}`,
      fatal: true,
    });
  }

  const storyComponent = resolveStoryComponent(story);

  useHead({ title: `${story.name} · Figma DS` });
</script>

<style lang="postcss" scoped>
  .pg-story-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;

    margin-bottom: 1.25rem;
  }

  .pg-story-meta__link {
    font-size: 0.75rem;
    font-weight: 600;
    color: #545454;
    text-decoration: none;

    &:hover {
      color: #1a1a1a;
      text-decoration: underline;
    }
  }

  .pg-story-meta__none {
    font-size: 0.75rem;
    color: #929292;
  }
</style>
